export const QA_NAME_APPLICANT_FIT_CHECK = 'applicantFitCheck'

export const QA_NAME_APPLICANT_FIT_CHECK_SCORE_LINE = 'applicantFitCheckScore'

export const QA_NAME_APPLICANT_FIT_CHECK_REEVALUATE =
  'applicantFitCheckReevaluate'

export const QA_NAME_APPLICANT_FIT_CHECK_STALE = 'applicantFitCheckStale'

export const QA_NAME_APPLICANT_FIT_CHECK_BREAKDOWN =
  'applicantFitCheckBreakdown'

export const MATCH_SCORE_REASON_NOT_ELIGIBLE = 'not_eligible'

export const MATCH_UNAVAILABLE_REASON_KEY = {
  listing_missing_availability: 'RentalPortal.MatchUnavailableAvailabilityKey',
}
